"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableSettingsAdminPage = void 0;
const DataTable_1 = require("@juvare/common-data-table-ui/DataTable");
const PageHeader_1 = require("@juvare/common-web-ui/PageHeader");
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const useSettingTable_1 = require("../hooks/useSettingTable");
const EditableSettingDialog_1 = require("./EditableSettingDialog");
const EditableSettingsAdminPage = () => {
    var _a;
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const { dataTableProps, reload, clearActiveRow } = (0, useSettingTable_1.useSettingTable)({
        useDataTableFunction: DataTable_1.useDataTableUsingUrl,
        onRowClick: () => undefined,
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(PageHeader_1.PageHeaderWithImage, { gradient: 'blue-base', title: t('editableSettings.settings') }),
        react_1.default.createElement(material_1.Box, { p: 4 },
            react_1.default.createElement(DataTable_1.DataTable, Object.assign({}, dataTableProps, { filteredRowCount: (_a = dataTableProps.filteredRowCount) !== null && _a !== void 0 ? _a : 0, loading: dataTableProps.loading }))),
        dataTableProps.activeRowId && (react_1.default.createElement(EditableSettingDialog_1.EditableSettingDialog, { name: dataTableProps.activeRowId, onClose: (changed) => {
                clearActiveRow();
                if (changed) {
                    reload();
                }
            } }))));
};
exports.EditableSettingsAdminPage = EditableSettingsAdminPage;
